import Attendance from "../../models/Attendance";
import { fetchTurnoPorEmpleado } from '../../controller/TurnoController';

const horaStrAMinutos = (horaStr) => {
  const [h, m] = horaStr.split(':').map(Number);
  return h * 60 + m;
};

export const parseAttendanceTardanzaResponse = async (responseData) => {
  const attendances = [];
  console.log("esto es lo que llega", responseData);

  for (const cedula in responseData) {
    const registros = responseData[cedula];
    const primerRegistro = registros[0];
    const empleadoId = primerRegistro.empleado_id;
    if (!empleadoId) continue;

    let turno;
    try {
      turno = await fetchTurnoPorEmpleado(empleadoId);
    } catch (error) {
      console.warn(`No se pudo obtener turno para empleado ${empleadoId}`);
      continue;
    }

    const registrosPorDia = {};
    registros.forEach((reg) => {
      const fecha = new Date(reg.fecha_hora);
      if (fecha.getHours() < 1) {
        fecha.setDate(fecha.getDate() - 1);
      }
      const claveFecha = fecha.toISOString().split('T')[0];
      if (!registrosPorDia[claveFecha]) registrosPorDia[claveFecha] = [];
      registrosPorDia[claveFecha].push(reg);
    });

    for (const fecha in registrosPorDia) {
      const entradas = registrosPorDia[fecha];
      entradas.sort((a, b) => new Date(a.fecha_hora) - new Date(b.fecha_hora));

      const primera = entradas[0];
      const fechaObj = new Date(primera.fecha_hora);

      const diasMap = {
        monday: "lunes",
        tuesday: "martes",
        wednesday: "miercoles",
        thursday: "jueves",
        friday: "viernes",
        saturday: "sabado",
        sunday: "domingo",
      };

      const diaSemanaIngles = fechaObj.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
      const diaSemana = diasMap[diaSemanaIngles];

      const turnoDia = turno[diaSemana];
      if (!turnoDia || !turnoDia.hora_inicio) continue;

      const entradaPermitida = horaStrAMinutos(turnoDia.hora_inicio);
      const horaEntradaRealStr = primera.fecha_hora.split('T')[1].slice(0, 5);
      const entradaReal = horaStrAMinutos(horaEntradaRealStr);

      if (entradaReal > entradaPermitida) {
        attendances.push(
          new Attendance({
            ...primera,
            cedula,
            tardanza_minutos: entradaReal - entradaPermitida,
            hora_entrada_permitida: turnoDia.hora_inicio.slice(0, 5),
            hora_entrada_real: horaEntradaRealStr,
          })
        );
      }
    }
  }

  return attendances;
};
